import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局样式（可选，建议创建src/assets/css/global.css）
import './assets/css/global.css'

// 注册Element UI
Vue.use(ElementUI)

// 生产环境提示关闭
Vue.config.productionTip = false

// 全局路由守卫：验证登录状态
router.beforeEach((to, from, next) => {
    // 需要登录的页面（白名单外的会员相关页面）
    const needLogin = /^\/member/.test(to.path) || to.path === '/publish'
    const isLogin = !!store.state.userInfo.token

    if (needLogin && !isLogin) {
        // 未登录跳转到登录页，并记录来源页
        next({path: '/login', query: {redirect: to.fullPath}})
    } else {
        next()
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
